import {Component, Input, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IDefaultService} from '../../service/v2/service/iDefault.service';
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {ErrorTextModule} from "../error-text/error-text.module";
import {IActionService} from "../../service/v2/service/action/iaction.service";
import {Subscription} from "rxjs";
import {AbstractFindOneByIdService} from "../../service/v2/service/findone/abstractFindOneById.service";

@Component({
  selector: 'app-service-container',
  templateUrl: './service-container.component.html',
  standalone: true,
  imports: [
    CommonModule,
    LoadingModule,
    ErrorTextModule,
  ]
})
export class ServiceContainerComponent {

  @Input() service: IDefaultService<any, any> | IActionService<any>;
  @Input() loadingMessage = 'Chargement en cours';
  @Input() errorMessage = 'Une erreur est survenue';
  @Input() displayLoadingIndicator = true;
  @Input() stickyLoading = false;
}
